export const shipments = {
  title: 'Lô hàng',
  resourceName: 'Lô hàng',
  totalVolume: 'Tổng khối (m³)',
  totalWeight: 'Tổng cân (kg)',
  createBtn: 'Tạo lô hàng',
  editBtn: 'Chỉnh sửa lô hàng',
  updateBtn: 'Cập nhật lô hàng',
  deleteBtn: 'Xóa lô hàng',
  deleteConfirm: 'Bạn có chắc chắn muốn xóa lô hàng này không?',
  inWarehouse: 'Trong kho',
  split: {
    title: 'Tách lô hàng',
    description: 'Chia lô hàng thành nhiều kiện nhỏ hơn.',
    successMessage: 'Tách lô hàng thành công.',
  },
  add: {
    forOrder: 'Cho đơn hàng {id}',
    viewOrder: 'Xem đơn hàng',
    placeholder:
      'Trang form thêm lô hàng đang được phát triển. Bạn có thể quay lại chi tiết đơn hàng hoặc danh sách lô hàng.',
  },
  bulkCreate: {
    title: 'Tạo lô hàng',
    addRow: 'Thêm dòng',
    duplicate: 'Nhân bản dòng',
    view: 'Xem trước',
    preview: 'Xem trước lô hàng',
    basicInfo: 'Thông tin cơ bản',
    dimensions: 'Kích thước kiện',
    warehouseInfo: 'Thông tin kho',
    additionalInfo: 'Thông tin bổ sung',
    totalRows: 'Tổng số dòng',
    summary: 'Tổng cộng',
    items: 'lô hàng',
    saving: 'Đang lưu...',
    createAll: 'Tạo tất cả lô hàng',
  },
  detail: {
    imagesTitle: 'Hình ảnh lô hàng',
    imagesDescription: 'Có thể thêm ảnh mới, xóa ảnh hoặc cập nhật lại ảnh kể cả khi lô hàng đã có ảnh.',
    updateImagesSuccess: 'Đã cập nhật ảnh lô hàng',
    updateImagesError: 'Cập nhật ảnh thất bại',
    saving: 'Đang lưu...',
    saveImages: 'Lưu ảnh',
    savedSuccess: 'Đã lưu thành công',
    pickImage: 'Chọn ảnh',
    captureImage: 'Chụp ảnh',
    uploading: 'Đang tải ảnh...',
    uploadSuccess: 'Đã tải lên {count} ảnh',
    uploadError: 'Tải ảnh thất bại',
    imageAlt: 'Ảnh {index}',
  },
  statuses: {
    ALL: 'Tất cả',
    IN_FROM_WAREHOUSE: 'Trong kho nguồn',
    TURN_AROUND: 'Hàng quay đầu',
    LOADING: 'Đang xếp container',
    IN_CONT: 'Trong container',
    DEPARTED: 'Khởi hành',
    ARRIVED: 'Cập cảng',
    RETURNED: 'Về kho',
    IN_TO_WAREHOUSE: 'Trong kho đích',
    ON_DELIVERY: 'Đang giao hàng',
    DELIVERED: 'Đã giao hàng',
    COMPLETED: 'Hoàn thành',
    LOST: 'Thất lạc',
  },
  searchCode: {
    label: 'Tìm theo mã lô hoặc mã vận đơn',
    placeholder: 'Nhập mã lô hoặc mã vận đơn',
  },
  searchProduct: {
    label: 'Tìm theo sản phẩm',
    placeholder: 'Nhập tên sản phẩm',
  },
  searchCustomer: {
    label: 'Tìm theo khách hàng',
    placeholder: 'Nhập mã khách hàng',
  },
  filterWarehouse: {
    label: 'Lọc theo kho',
    placeholder: 'Chọn kho',
  },
  filterStartDate: {
    label: 'Hàng về từ ngày',
    placeholder: 'Chọn ngày bắt đầu',
  },
  filterEndDate: {
    label: 'Hàng về đến ngày',
    placeholder: 'Chọn ngày kết thúc',
  },
  filterStatus: {
    label: 'Lọc theo trạng thái',
    placeholder: 'Chọn trạng thái',
  },
  filter: {
    placeholder: 'Tìm theo mã vận đơn, mã lô hàng...',
    advancedFilter: 'Lọc nâng cao',
    clearFilter: 'Xóa lọc',
    search: 'Tìm kiếm',
    ladingCodeOrder: 'Mã vận đơn / đơn hàng',
    ladingCode: 'Mã vận đơn',
    productNameLabel: 'Tên hàng',
    productNamePlaceholder: 'Tên sản phẩm',
    customerCodeLabel: 'Mã khách hàng',
    warehousePlaceholder: 'Kho',
    statusLabel: 'Trạng thái',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    all: 'Tất cả',
  },
  list: {
    selectedCount: 'Đã chọn {count} lô hàng',
    deleting: 'Đang xóa...',
    deleteSelected: 'Xóa đã chọn',
    deleteConfirmOne: 'Bạn có chắc muốn xóa lô hàng này?',
    deleteSuccess: 'Đã xóa lô hàng',
    bulkDeleteConfirm: 'Xóa {count} lô hàng đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} lô hàng',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    viewMore: 'Xem thêm',
    noImages: 'Chưa có ảnh',
    ladingCode: 'Mã vận đơn',
    viewDetail: 'Xem chi tiết',
    edit: 'Sửa',
    duplicate: 'Nhân bản',
    split: 'Tách',
    delete: 'Xóa lô hàng',
    duplicateConfirm: 'Bạn có chắc muốn nhân bản lô hàng này?',
    duplicateSuccess: 'Nhân bản lô hàng thành công',
    duplicateError: 'Nhân bản lô hàng thất bại',
    splitSuccess: 'Tách lô hàng thành công',
    splitError: 'Tách lô hàng thất bại',
    splitDialogTitle: 'Tách lô hàng',
    splitDialogDescription: 'Lô hàng hiện tại có {count} kiện. Nhập số kiện cho lô hàng mới (tối đa {max} kiện).',
    splitNewPackLabel: 'Số kiện mới',
    splitInvalidRange: 'Vui lòng nhập số từ 1 đến {max}',
    cancel: 'Hủy',
    splitBtn: 'Tách',
    processing: 'Đang xử lý...',
    actions: 'Thao tác',
  },
  export: {
    button: 'Export',
    loading: 'Đang xuất...',
    success: 'Xuất file Excel thành công',
    failed: 'Xuất file Excel thất bại',
    sheetName: 'Danh sách lô hàng',
    fileName: 'Danh_sach_lo_hang_{date}.xlsx',
    imageButton: 'Export Image',
    columns: {
      orderCode: 'Mã đơn hàng',
      ladingCode: 'Mã vận đơn',
      code: 'Mã lô hàng',
      customerCode: 'Khách hàng',
      subCustomerCode: 'Mã sub KH',
      productName: 'Tên hàng',
      numberOfPack: 'Số kiện',
      totalDimensionInM3: 'Thể tích (m³)',
      totalWeight: 'Cân nặng',
      fromWarehouseName: 'Kho đi',
      toWarehouseName: 'Kho đến',
      containerRefCode: 'Container',
      statusLabel: 'Trạng thái',
      orderCreatedAt: 'Ngày tạo đơn',
      notes: 'Ghi chú',
      createdAt: 'Ngày tạo',
      updatedAt: 'Ngày cập nhật',
    },
  },
  fields: {
    order: 'Đơn hàng',
    code: 'Mã lô hàng',
    customer: 'Khách hàng',
    customerCode: 'Mã khách hàng',
    images: 'Hình ảnh',
    productName: 'Tên sản phẩm',
    productNameCn: 'Tên sản phẩm (tiếng Trung)',
    totalVolume: 'Tổng khối (m³)',
    totalWeight: 'Tổng cân (kg)',
    // Backward compatibility keys
    numberOfPack: 'Số kiện',
    numberOfPackage: 'Số kiện hàng',
    warehouse: 'Kho',
    fromWarehouse: 'Kho xuất',
    toWarehouse: 'Kho nhập',
    container: 'Container',
    status: 'Trạng thái',
    pricePerKg: 'Giá mỗi kg',
    pricePerM3: 'Giá mỗi m³',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    orderCreate: 'Ngày hàng về',
    orderCreatedAt: 'Ngày hàng về',
    notes: 'Ghi chú',
    index: 'STT',
    info: 'Thông tin',
    priceByWeight: 'Giá theo cân',
    priceByVolume: 'Giá theo kích thước',
    finalPrice: 'Giá cuối',
    subCustomerCode: 'Mã khách hàng (mã phụ)',
    ladingCode: 'Mã vận đơn',
    dimensions: 'Kích thước kiện',
    lengthOfPack: 'Chiều dài kiện (cm)',
    widthOfPack: 'Chiều rộng kiện (cm)',
    heightOfPack: 'Chiều cao kiện (cm)',
    weightOfPack: 'Trọng lượng kiện (kg)',
    productDimensions: 'Kích thước sản phẩm',
    lengthOfProduct: 'Chiều dài sản phẩm (cm)',
    widthOfProduct: 'Chiều rộng sản phẩm (cm)',
    heightOfProduct: 'Chiều cao sản phẩm (cm)',
    weightOfProduct: 'Trọng lượng sản phẩm (kg)',
    productMaterial: 'Chất liệu sản phẩm',
    information: 'Thông tin sản phẩm',
    createdBy: 'Người tạo',
    customerInfo: 'Thông tin khách hàng',
    packingInfo: 'Thông tin đóng kiện',
    productInfo: 'Thông tin sản phẩm',
    actions: 'Hành động',
    // Additional fields for ShipmentShow
    mainCode: 'Mã chính',
    subCode: 'Mã phụ',
    notAssignedCustomer: 'Chưa gắn khách',
    numberOfPackages: 'Số lượng kiện hàng',
    packingDimensions: 'Kích thước đóng gói',
    totalVolumeInM3: 'Tổng thể tích (m³)',
    totalWeightInKg: 'Tổng trọng lượng (kg)',
    totalDimension: 'Tổng thể tích (m³)',
    totalDimensionInM3: 'Tổng thể tích (m³)',
    productNameChinese: 'Tên sản phẩm (Tiếng Trung)',
    additionalInfo: 'Thông tin bổ sung',
    additionalInformation: 'Thông tin bổ sung',
    warehouseInfo: 'Thông tin kho',
    containerInfo: 'Thông tin container',
    containerStatus: 'Trạng thái container',
    fromPort: 'Cảng đi',
    toPort: 'Cảng đến',
    agency: 'Đại lý',
    shippingLine: 'Hãng tàu',
    noContainerInfo: 'Chưa có thông tin container',
    product: 'Sản phẩm',
    confirmationImage: 'Ảnh xác nhận',
    // Timeline translations
    timeline: {
      title: 'Thông tin lịch trình',
      steps: {
        inSourceWarehouse: 'Vào kho nguồn',
        inContainer: 'Vào container',
        departed: 'Khởi hành',
        arrived: 'Cập cảng',
        inDestinationWarehouse: 'Nhập kho đích',
        delivered: 'Giao hàng',
      },
      descriptions: {
        inSourceWarehouse: 'Hàng hóa được nhập vào kho nguồn',
        inContainer: 'Hàng hóa được đưa vào container',
        departed: 'Container khởi hành từ cảng đi',
        arrived: 'Container đã đến cảng đích',
        inDestinationWarehouse: 'Hàng hóa đã được nhập vào kho đích',
        delivered: 'Hàng hóa đã được giao đến khách hàng',
      },
    },
    // Additional translations for other components
    warehouseSection: {
      goodsInWarehouse: 'Hàng trong kho',
      goodsInWarehouseWithCount: 'Hàng trong kho: {count} lô',
      noShipmentsFound: 'Không tìm thấy lô hàng nào',
      customerCode: 'Mã khách hàng',
      subCodeId: 'ID sub code',
      containerId: 'ID container',
      containerCode: 'Mã container',
      shipmentPrice: 'Giá lô',
      deliveryNote: 'Phiếu giao hàng',
      deliveryNoteAdded: 'Đã được thêm vào phiếu giao hàng {code}',
      notAdded: 'Chưa có',
      total: 'Tổng',
      selectedShipments: '{count} lô hàng đã chọn',
      weight: 'Cân nặng',
      volume: 'Khối lượng',
      price: 'Giá',
      weightPerPack: 'Cân nặng/kiện',
      noName: 'Không có tên',
      numberOfPacks: 'Số kiện',
    },
    actionsSection: {
      toWarehouse: 'Vào kho',
      missingPackages: 'Thiếu kiện',
      missingPackagesTitle: 'Thiếu kiện',
      enterActualPackages: 'Nhập số kiện thực tế',
      valueMustBeBetween: 'Giá trị phải nằm trong khoảng 0 đến {max}',
      missingPackagesDueTo: 'Các kiện thiếu là do:',
      lostPackages: 'Kiện bị mất',
      missingFromSourceWarehouse: 'Thiếu tại kho nguồn',
      packagesInSystem: 'Số kiện trong hệ thống',
      actualPackages: 'Số kiện thực tế',
      willGoToDestination: '(Sẽ vào kho đích)',
      missing: 'Thiếu',
      packages: 'kiện do',
      missingFromSource: 'Thiếu đóng gói tại kho nguồn',
      cancel: 'Hủy',
      processing: 'Đang xử lý...',
      save: 'Lưu',
    },
    MVD: 'Mã vận đơn',
    actual: 'Thực tế',
  },
  tabs: {
    general: 'Thông tin chung',
    shipments: 'Lô hàng',
    price: 'Thông tin giá',
    customsDeclaration: 'Thông tin tờ khai cho lô hàng',
  },
  totalPriceShipments: 'Tổng giá theo lô',
  totalPrice: 'Tổng giá',
  titles: {
    view: 'Chi tiết lô hàng',
    show: 'Chi tiết lô hàng',
    edit: 'Chỉnh sửa lô hàng',
    create: 'Tạo lô hàng',
    list: 'Danh sách lô hàng',
  },
  buttons: {
    removeFromContainer: 'Bỏ lô khỏi Container',
    saveOrder: 'Lưu thứ tự lô hàng',
    confirmation: 'Xác nhận',
    shareShipment: 'Chia sẻ danh sách',
  },
  messages: {
    noData: 'Không có dữ liệu',
    totalShipments: 'Tổng: {total} lô hàng',
    customerSelected: 'Đã chọn khách hàng',
    haveSubCodeButNoCustomer: 'Tìm thấy mã phụ nhưng không có khách hàng tương ứng',
    notFoundCustomerWithCode: 'Không tìm thấy khách hàng với mã code này',
    errorFetchingCustomer: 'Lỗi khi tìm kiếm mã khách hàng',
    required: {
      numberOfPack: 'Vui lòng nhập số lượng kiện',
      subCustomerCode: 'Vui lòng nhập mã khách hàng',
      lengthOfPack: 'Vui lòng nhập chiều dài',
      widthOfPack: 'Vui lòng nhập chiều rộng',
      heightOfPack: 'Vui lòng nhập chiều cao',
      weightOfPack: 'Vui lòng nhập trọng lượng',
      pricePerKg: 'Vui lòng nhập giá theo kg',
      pricePerM3: 'Vui lòng nhập giá theo m³',
      fromWarehouseId: 'Vui lòng chọn kho xuất',
      toWarehouseId: 'Vui lòng chọn kho nhập',
      containerId: 'Vui lòng chọn container',
      productName: 'Vui lòng nhập tên sản phẩm',
      images: 'Vui lòng tải lên hình ảnh',
    },
    positive: {
      numberOfPack: 'Số lượng kiện phải lớn hơn hoặc bằng 0',
      lengthOfPack: 'Chiều dài phải lớn hơn hoặc bằng 0',
      widthOfPack: 'Chiều rộng phải lớn hơn hoặc bằng 0',
      heightOfPack: 'Chiều cao phải lớn hơn hoặc bằng 0',
      weightOfPack: 'Trọng lượng phải lớn hơn hoặc bằng 0',
    },
    warehouse: {
      toWarehouseId: '"Kho nhập" phải khác "Kho xuất"',
    },
  },
  form: {
    createTitle: 'Tạo lô hàng',
    editTitle: 'Chỉnh sửa lô hàng',
    help: {
      numberOfPack: 'Số kiện hàng trong lô hàng',
      subCustomerCode: 'Mã khách hàng (mã phụ) cho lô hàng',
      customer: 'Khách hàng sẽ được tự động lựa chọn dựa trên mã phụ',
      ladingCode: 'Mã vận đơn cho lô hàng',
      productName: 'Tên sản phẩm trong lô hàng',
      productNameCn: 'Tên sản phẩm bằng tiếng Trung (nếu có)',
      selectFromWarehouse: 'Chọn kho hàng đi',
      selectToWarehouse: 'Chọn kho hàng đến',
    },
  },
  customsDeclaration: {
    title: 'Thông tin tờ khai cho lô hàng',
    description: 'Phần này chứa thông tin tờ khai hải quan cho lô hàng.',
    fields: {
      customsDeclarationNumber: 'Số tờ khai hải quan',
      customsDeclarationDate: 'Ngày tờ khai hải quan',
      customsOffice: 'Cơ quan hải quan',
      customsAgent: 'Đại lý hải quan',
      importExportType: 'Loại hình nhập khẩu/xuất khẩu',
      goodsDescription: 'Mô tả hàng hóa',
      hsCode: 'HS Code',
      quantity: 'Số lượng',
      unitValue: 'Giá trị đơn vị',
      totalValue: 'Tổng giá trị',
      currency: 'Tiền tệ',
      shipments: 'Lô hàng',
    },
  },
}
